export { CustomerAccessRequiredPage } from './CustomerAccessRequiredPage'
export { CustomerActivateAccountPage } from './CustomerActivateAccountPage'
export { CustomerAddressesPage } from './CustomerAddressesPage'
export { CustomerAuthPage } from './CustomerAuthPage'
export { CustomerDashboardPage } from './CustomerDashboardPage'
export { CustomerForgotPasswordPage } from './CustomerForgotPasswordPage'
export { CustomerInitializingPage } from './CustomerInitializingPage'
export { CustomerOrderDetailPage } from './CustomerOrderDetailPage'
export { CustomerOrdersListPage } from './CustomerOrdersListPage'
export { CustomerPreferencesPage } from './CustomerPreferencesPage'
export { CustomerProfilePage } from './CustomerProfilePage'
export { CustomerPrivacyPage } from './CustomerPrivacyPage'
export { CustomerResetPasswordPage } from './CustomerResetPasswordPage'
export { CustomerSectionPlaceholderPage } from './CustomerSectionPlaceholderPage'
export { CustomerSupportDetailPage } from './CustomerSupportDetailPage'
export { CustomerSupportPage } from './CustomerSupportPage'
